import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-base bg-opacity-80 bg-blue-200 mt-3" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Statistics ")
const _hoisted_3 = {
  key: 0,
  class: "m-1 table-auto text-xs bg-opacity-40 bg-white"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("td", { class: "text-left" }, "Papers inspected", -1)
const _hoisted_5 = { class: "text-right" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("td", { class: "text-left" }, "Reused papers (DOI)", -1)
const _hoisted_8 = { class: "text-right" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", { class: "text-left" }, "Reused papers (arXiv)", -1)
const _hoisted_11 = { class: "text-right" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("td", { class: "text-left" }, "Reused repositories (GitHub)", -1)
const _hoisted_14 = { class: "text-right" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", { class: "text-left" }, "Reused websites", -1)
const _hoisted_17 = { class: "text-right" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    class: "w-full text-center",
    colspan: "2"
  }, "Reuse types")
], -1)
const _hoisted_20 = {
  class: "text-center",
  colspan: "2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h2", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("button", {
        class: "float-right",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.open = !$setup.open))
      }, _toDisplayString($setup.open ? "🔼" : "🔽"), 1)
    ]),
    ($setup.open)
      ? (_openBlock(), _createElementBlock("table", _hoisted_3, [
          _createElementVNode("tr", null, [
            _hoisted_4,
            _createElementVNode("td", _hoisted_5, [
              ($setup.useFilter)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString($setup.filteredPapersInspected) + "/", 1))
                : _createCommentVNode("", true),
              _createTextVNode(_toDisplayString($setup.papersInspected), 1)
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_7,
            _createElementVNode("td", _hoisted_8, [
              ($setup.useFilter)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString($setup.filteredTargetDoiNodes) + "/", 1))
                : _createCommentVNode("", true),
              _createTextVNode(_toDisplayString($setup.targetDoiNodes), 1)
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_10,
            _createElementVNode("td", _hoisted_11, [
              ($setup.useFilter)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString($setup.filteredArxivNodes) + "/", 1))
                : _createCommentVNode("", true),
              _createTextVNode(_toDisplayString($setup.targetArxivNodes), 1)
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_13,
            _createElementVNode("td", _hoisted_14, [
              ($setup.useFilter)
                ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString($setup.filteredGitHubNodes) + "/", 1))
                : _createCommentVNode("", true),
              _createTextVNode(_toDisplayString($setup.targetGitHubNodes), 1)
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_16,
            _createElementVNode("td", _hoisted_17, [
              ($setup.useFilter)
                ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString($setup.filteredWebsiteNodes) + "/", 1))
                : _createCommentVNode("", true),
              _createTextVNode(_toDisplayString($setup.targetWebsiteNodes), 1)
            ])
          ]),
          _hoisted_19,
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_20, _toDisplayString($setup.edgeTypes), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}